define('gameday-index-configurator/src/model/valueObjects/GDConfig',['require','exports','module','jquery'],function(require, exports, module){
    var $ = require("jquery");

	function GDConfig(props) {
        this.data = $.extend({},props);
	}

    GDConfig.prototype = {
        getGame: function() {
            return this.data.game || null;
        }
    }
	return GDConfig;
});
